import React from "react";
import "../styles/pricing.css";
import PortfolioNavbar from "./elements/portfolionavbar";
import PortfolioFooter from "./elements/portfoliofooter";
import PricingCard from "./elements/pricingcard";
import PortfolioFaq from "./elements/portfoliofaq";
import TestimonialsRow from "./elements/testimonialsrow";
import GrowWithNeurogen from "./elements/growwithneurogen";
export default function Pricing() {
  const plans = [
    {
      mode: "Basic",
      price: 199,
      description: "Best for beginners wanting a simple start.",
      features: [
        "Limited Query",
        "Limited Diagnosis",
        "Limited Image Diagnosis",
        "Limited Investigatory Based Dx",
        "Limited Case Simulation",
        "Limited Q Bank",
        "Limited Expert Advice",
      ],
    },
    {
      mode: "Essential",
      price: 999,
      description: "Perfect for professionals needing advanced tools.",
      features: [
        "Unlimited Query",
        "Limited Diagnosis",
        "Limited Image Diagnosis",
        "Limited Investigatory Based Dx",
        "Limited Case Simulation",
        "Limited Q Bank",
        "Limited Expert Advice",
      ],
    },
    {
      mode: "Visionary",
      price: 1499,
      description: "For visionaries aiming for unlimited capabilities.",
      features: [
        "Unlimited Query",
        "Unlimited Diagnosis",
        "Unlimited Image Diagnosis",
        "Unlimited Investigatory Based Dx",
        "Unlimited Case Simulation",
        "Unlimited QBank",
        "Unlimited Expert Advice",
      ],
    },
  ];

  return (
    <div className="portfolio">
      <div className="portfoliopadding">
        <div className="portfoliohome">
          <PortfolioNavbar colortheme="blue" />
        </div>
        <div className="pricinghome">
          <div className="teammembersheader">
            <h2 className="h2headerportfolio">Plans & Pricing</h2>
            <p>Start with a Subscription that Best Suits you Today</p>
          </div>
          <div className="pricingrow">
            {plans.map((plan, index) => (
              <PricingCard
                key={index}
                mode={plan.mode}
                price={plan.price}
                description={plan.description}
                features={plan.features}
              />
            ))}
          </div>
        </div>
        <div className="portfoliotestimonials mt-16">
          <h2 className="h2headerportfolio">Loved by Innovators</h2>
          <div className="portfoliotestimonialsrow">
            <TestimonialsRow />
          </div>
        </div>
        <PortfolioFaq />
        <GrowWithNeurogen />
        <PortfolioFooter />
      </div>
    </div>
  );
}
